export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_MOMENT_FORMAT = 'DD/MM/YYYY';
